// Internal Components
import HintBox from "./HintBox";
import PlaceConfirmed from "./PlaceConfirmed";
import Pay from "./Pay";
import All from "./All";

// Internal Helpers and Utilities
import useMapState from "../../helpers/mapState";

export default function MainForm({ sendReq, mapRef }) {
  const { pay } = useMapState();

  return (
    <div>
      {!pay && (
        <>
          {" "}
          <HintBox />
          <PlaceConfirmed mapRef={mapRef} />
          <All sendReq={sendReq} />{" "}
        </>
      )}

      <Pay />
    </div>
  );
}
